<template src='./preparedness.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import FormSetup from '@/components/misc/form-setup/FormSetup'

const CURRENCY_ID_1 = 'root.financial data.socio-economic context.funding.sources'
const ORGANIZATION_ID = 'root.basic info.proposer organization'

export default {
  components: {
    'form-setup': FormSetup
  },
  data () {
    return {
      autoCompleteUrl_currency: Vue.$apiConfig.exchangeRateGet,
      autoCompleteUrl_budgetId: Vue.$apiConfig.budgetUsersGet,
      help: {
        form: Vue.$helpConfig.projectFormPreparedness
      },
      formMarkdownElements: [
        {
          editor: 'root.project description',
          element: 'root[project description]',
          name: 'project description'
        }
      ]
    }
  },
  methods: {
    fetchOrganization (query) {
      const queryParamName = '?filter[search]=' + query
      const url = this.autoCompleteUrl_budgetId
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url + queryParamName)
      return Promise.race([cancel, request])
    },
    fetchCurrency (query) {
      const queryParamName = '?filter[code]&filter[search]=' + query
      const url = this.autoCompleteUrl_currency
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url + queryParamName)
      return Promise.race([cancel, request])
    },
    setupPage () {
      if (this.$refs.setup) {
        this.$refs.setup.loading = true
      }
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.$route.params.phaseFormId)
        .then(
          response => {
            // this.logConsole(response)
            const form = response.data.payload
            this.$refs.setup.formName = form.name
            this.$refs.setup.project = response.data.additionalInformation
            this.$refs.setup.formStatus = form.status
            this.$refs.setup.formCode = form.code
            this.$refs.setup.formatRevisions(form.inputJsonRevisions, 'pif-mini')
            this.$refs.setup.pif = JSON.parse(form.json)
            this.$refs.setup.initialSchema = this.initialActivityYears(this.$refs.setup.pif.schema) // this.$refs.setup.pif.schema
            this.$refs.setup.initialConfig = this.$refs.setup.pif.config
            this.initializeEditor()
            this.$refs.setup.initialVal = form.inputJson === '{}' ? this.$refs.setup.editor.getValue() : JSON.parse(form.inputJson)
            this.$refs.setup.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.$refs.setup.loading = false
          }
        )
    },
    changeRevision (selectedRevision) {
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.$route.params.phaseFormId + '/revision/' + selectedRevision)
        .then(
          response => {
            this.logConsole(response)
            const revision = response.data.payload
            this.$refs.setup.pif = JSON.parse(revision.json)
            this.$refs.setup.initialSchema = this.$refs.setup.pif.schema
            this.$refs.setup.initialConfig = this.$refs.setup.pif.config
            this.$refs.setup.initialVal = revision.inputJson ? JSON.parse(revision.inputJson) : null
            this.initializeEditor()
            history.pushState({}, null, ('/projects/' + this.$refs.setup.projectCode + '/phases/' + Number(this.$refs.setup.projectPhaseId) + '/forms/preparedness/id/' + Number(this.$refs.setup.phaseFormId) + '/revision/' + this.$refs.setup.revision.revision))
          },
          error => {
            this.formatErrorResponse(error)
            this.$refs.setup.loading = false
          }
        )
    },
    initializeEditor () {
      this.$refs.setup.configureEditor()
      this.initialCurrencyAutoComplete(CURRENCY_ID_1, '.currency')
      this.initialOrganizationAutoComplete()

      this.$refs.setup.editor.on('ready', () => {
        this.initialMarkdownControls()
        if (this.$refs.setup.initialVal) {
          this.$refs.setup.saveJsonValues(this.$refs.setup.initialVal)
        }
        this.$refs.setup.manageInput()

        this.initialCurrencyAutoComplete(CURRENCY_ID_1, '.currency')
        this.initialOrganizationAutoComplete()
        this.roundNumberValues()
      })

      // console.log(this.$refs.setup.editor)
      this.$refs.setup.editor.on('change', () => {
        const values = this.$refs.setup.editor.getValue()
        const val = this.$refs.setup.initialVal
        this.$refs.setup.formChanged = !this.deepEqual(val, values)

        const fundingTotal = this.$refs.setup.editor.getEditor('root.financial data.socio-economic context.funding.funding totals')
        fundingTotal.header.innerHTML = this.formatFundingCalculation(values)
      })
      // console.log(this.$refs.setup.editor)
    },
    initialActivityYears (schema) {
      const sc = schema
      var years = []
      var currentYear = new Date().getFullYear()
      years.push(' ')
      for (var i = currentYear - 15; i <= currentYear + 15; i++) {
        years.push(i.toString())
      }
      this.logConsole(schema)
      sc.definitions.years.enum = years
      return schema
    },
    initialMarkdownControls () {
      if (!this.$refs.setup.markdownElements) return
      for (var j = 0; j < this.$refs.setup.markdownElements.length; j++) {
        this.$refs.setup.configureMarkdownElement(this.$refs.setup.markdownElements[j])
        if (this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[j].editor)) {
          this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[j].editor).simplemde_instance.codemirror.on('change', () => {
            const values = this.$refs.setup.editor.getValue()
            values[this.$refs.setup.markdownElements[0].name] = this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[0].editor).simplemde_instance.value()
            const val = this.$refs.setup.initialVal
            this.$refs.setup.formChanged = !this.deepEqual(val, values)
          })
        }
      }
    },
    formatFundingCalculation (values) {
      this.getFundingCalculation(values)
      let data = ''
      for (var j = 0; j < this.fundingCalculations.length; j++) {
        data += '<tr><td>' + this.fundingCalculations[j].currency + '</td><td>' + this.formatAmount(this.fundingCalculations[j].amount) + '</td></tr>'
      }
      if (data !== '') {
        return `Укупно:
            <div class="table_wrapper">
              <table id ="sumActivities">
                <thead style="text-align:right">
                  <tr>
                    <th>Валута</th>
                    <th>Тотал</th>
                  </tr>
                </thead>
                <tbody style="text-align:right">` + data + `</tbody>
              </table>
            </div>`
      } else {
        return ''
      }
    },
    getFundingCalculation (values) {
      this.fundingCalculations = []
      const fundings = values['financial data']['socio-economic context'].funding.sources
      var totalAmount = 0
      totalAmount = this.sum(fundings.map(item => item['local amount']))
      totalAmount = totalAmount === '' ? 0 : parseFloat(totalAmount)
      this.fundingCalculations.push({ currency: 'РСД', amount: totalAmount })
    },
    initialOrganizationAutoComplete () {
      this.addNewAutocomplete(ORGANIZATION_ID, this.fetchOrganization)
    },
    initialCurrencyAutoComplete (name, sufix) {
      if (this.$refs.setup.editor.editors[name]) {
        for (let i = 0; i <= this.$refs.setup.editor.editors[name].rows.length - 1; i++) {
          this.addNewAutocomplete(name + '.' + i + sufix, this.fetchCurrency)
        }

        this.$refs.setup.editor.editors[name].add_row_button.onclick = (result) => {
          return this.addNewCurrencyAutocomplete(name, sufix)
        }
      }
    },
    addNewCurrencyAutocomplete (controlName, sufix) {
      const index = this.$refs.setup.editor.editors[controlName].rows.length - 1
      const name = controlName + '.' + index + sufix
      this.addNewAutocomplete(name, this.fetchCurrency)
    },
    addNewAutocomplete (name, fetchFunction) {
      this.$refs.setup.editor.editors[name].options.autocomplete.search = function (input) {
        return new Promise(function (resolve) {
          if (input.length < 2) {
            return resolve([])
          }
          fetchFunction(input).then(function (response) {
            return response.json()
          }).then(function (data) {
            resolve(data.payload)
          })
        })
      }

      this.formatAutocompleteResult(name)
    },
    formatAutocompleteResult (name) {
      this.$refs.setup.editor.editors[name].options.autocomplete.getResultValue = (result) => {
        return name.includes('currency') ? result.exchangeCode + ' ' + this.formatAmount(result.exchangeRate) : result.id + ' - ' + result.name
      }
      this.$refs.setup.editor.editors[name].options.autocomplete.renderResult = (result, props) => {
        const title = name.includes('currency') ? result.exchangeCode : result.id
        const subtitle = name.includes('currency') ? this.formatAmount(result.exchangeRate) : result.name

        return ['<li ' + props + '>',
          '<div class="wiki-title">' + title + '</div>',
          '<div class="wiki-snippet"><small>' + subtitle + '<small></div>',
          '</li>'].join('')
      }
    },
    roundNumberValues () {
      const editors = this.$refs.setup.editor.editors
      for (const key in editors) {
        if (editors[key].format === 'integer') {
          editors[key].setValue(this.formatAmount(this.formatNumber(editors[key].getValue()), 0))
        }
      }
    }
  },
  created () {
    this.setupPage()
    EventBus.$on('setupPage', () => {
      if (this.$refs && this.$refs.setup) {
        this.$refs.setup.revision = {
          revision: null
        }
      }
      this.setupPage()
    })
    EventBus.$on('changeRevision', (revision) => {
      this.changeRevision(revision)
    })
  },
  beforeDestroy () {
    EventBus.$off('setupPage')
    EventBus.$off('changeRevision')
  }
}
</script>
